import React from "react";
import { connect, } from "react-redux";
import { Redirect, } from "react-router-dom";

// --------------------------------------------------

class Logout extends React.Component {
	componentDidMount() {
		this.props.dispatch({
			type: "CLEAR_TOKEN",
		});
	}

	render() {
		return <Redirect to = "/"/>;
	}
}

export default connect()(Logout);


// WEBPACK FOOTER //
// ./src/components/Logout.js